/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 4/12/16.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('bitrate', function() {
	return function(bytes) {
		if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
			return 'NaN';
		}
		var units = ['bps', 'kbps', 'mbps', 'gbps'],
		number = Math.floor(Math.log(bytes) / Math.log(1000));
		return (bytes / Math.pow(1000, Math.floor(number))).toFixed(2) + ' ' + units[number];
	};
});
